import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * ログイン必須のルートをガードする。
 * 未ログインの場合は /login にリダイレクトし、returnTo で元のパスを渡す。
 */
function RequireAuth({ user, loadingUser, children }) {
  const location = useLocation();

  if (loadingUser) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-pink-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    const returnTo = location.pathname + location.search;
    const loginPath = returnTo && returnTo !== '/' ? `/login?redirect=${encodeURIComponent(returnTo)}` : '/login';
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }

  return children;
}

export default RequireAuth;
